import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import {
  MobileNavLinkConfig,
  NavbarButtonConfig,
} from '../../../core/interfaces/site-config.interface';
import { SiteConfigService } from '../../../core/services';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset).pipe(
    map((result) => result.matches),
    shareReplay(),
  );

  isMobileMenuOpen = false;
  navbarButtons: NavbarButtonConfig[] = [];
  mobileNavLinks: MobileNavLinkConfig[] = [];
  mobileTopLinks: MobileNavLinkConfig[] = [];
  mobileBottomLinks: MobileNavLinkConfig[] = [];

  constructor(
    private breakpointObserver: BreakpointObserver,
    private siteConfigService: SiteConfigService,
  ) {}

  ngOnInit(): void {
    this.siteConfigService.getConfig().subscribe((config) => {
      if (config?.navbar?.buttons) {
        this.navbarButtons = config.navbar.buttons.filter((button) => button.enabled);
      }

      if (config?.mobileNav?.links) {
        this.mobileNavLinks = config.mobileNav.links.filter((link) => link.enabled !== false);
        // Separate links by section
        this.mobileTopLinks = this.mobileNavLinks.filter((link) => link.section !== 'bottom');
        this.mobileBottomLinks = this.mobileNavLinks.filter((link) => link.section === 'bottom');
      }
    });
  }

  toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
    // Prevent scrolling when menu is open
    document.body.style.overflow = this.isMobileMenuOpen ? 'hidden' : '';

    // Add class to body to help with styling when menu is open
    if (this.isMobileMenuOpen) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }
  }

  closeMobileMenu(): void {
    this.isMobileMenuOpen = false;
    document.body.style.overflow = '';
    document.body.classList.remove('menu-open');
  }

  isInternalLink(link: MobileNavLinkConfig): boolean {
    return link.type === 'internal';
  }

  getLinkPath(href: string): string {
    // Extract path before the hash
    return href.split('#')[0] || '/';
  }

  getLinkFragment(href: string): string | undefined {
    // Extract fragment after the hash
    const parts = href.split('#');
    return parts.length > 1 ? parts[1] : undefined;
  }
}
